const searchableDropdownClass = 'SearchableDropdown';
const searchBarClass = 'SearchableDropdown__SearchBar';
const dropdownChoicesListClass = 'SearchableDropdown__Choice'; 
const hiddenClass = 'SearchableDropdown__Choice--hidden';

export function initializeDropdownSearch() {
  const $searchableDropdowns = document.querySelectorAll(`.${searchableDropdownClass}`)

  $searchableDropdowns.forEach($searchableDropdown => {
    const $searchBar = $searchableDropdown.querySelector(`.${searchBarClass}`);
    const $dropdownChoicesList = $searchableDropdown.querySelectorAll(`.${dropdownChoicesListClass}`);

    $searchBar.addEventListener("input", (event) => {
      const search = event.target.value.toLowerCase();
      
      $dropdownChoicesList.forEach($choice => {
        if ($choice.dataset.search) {
          const isChoiceVisible = $choice.dataset.search.toLowerCase().includes(search);
          $choice.classList.toggle(hiddenClass, !isChoiceVisible);
        }
      });
    });

    document.addEventListener("click", (event) => {
      const $searchableDropdown = event.target.closest(`.${searchableDropdownClass}`);
      if ($searchableDropdown === null) {
        $searchBar.value = "";
        $dropdownChoicesList.forEach(choice => {
          choice.classList.remove(hiddenClass);
        });
      }
    });
  });
}
